import { Error } from '@mui/icons-material';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from "react-i18next";

interface ErrorMessageProps extends PropsWithChildren {
  icon?: JSX.Element;
}

const ErrorMessage: FC<ErrorMessageProps> = ({
  icon = <Error/>, 
  children = undefined
}) => {
  const { t } = useTranslation();

  const DEFAULT_MESSAGE = (
    <div>
      {t('common:text.message_cant_do_operation')}
    </div>
  );

  return (
    <div style={{display: 'flex'}}>
      <div style={{marginRight: '10px'}}>{icon}</div>
      {children ?? DEFAULT_MESSAGE}
    </div>
  );
};

export default ErrorMessage;
